import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { Contract } from '../../model/contract';
import { ContractService } from '../base/contract';

@Injectable()
export class WithdrawApprovalCommandHandler implements ICommandHandler {
  constructor(private _service: ContractService<Contract>) {}

  canExecute(command: Command): boolean {
    return command.id === leaseAgreementCommand.withdrawApproval;
  }

  execute(command: Command): Observable<boolean> {
    return this._service.withdrawApproval(command.context.id).pipe(
      map(status => {
        command.context.status = status;
        return true;
      })
    );
  }
}
